<template>
  <table>
    <tr>
      <th bgcolor="gray" width="100"></th>
      <th bgcolor="orange">
        01<br />月
      </th>
      <th bgcolor="orange">
        02<br />火
      </th>
      <th bgcolor="orange">
        03<br />水
      </th>
    </tr>
    <!-- <template v-for="(item, index) in list">
      <tr>
        <td>{{ item.moneyA }}</td>
        <td>{{ item.moneyB }}</td>
      </tr>
      <tr v-if="index === list.length - 1">
        <td>{{ totalMoney('A') }}</td>
        <td>{{ totalMoney('B') }}</td>
      </tr>
    </template> -->
  </table>
</template>

<script>
export default {
  name: "App",
  created() {
    this.formedDateOfThisWeek()
  },
  data() {
    return {
      list: [
        { moneyA: 1000, moneyB: 4000 },
        { moneyA: 2000, moneyB: 5000 },
        { moneyA: 3000, moneyB: 6000 },
      ],
    };
  },
  methods: {
    totalMoney(type) {
      let sum = 0;
      for (const item of this.list) {
        if (type === "A") {
          sum += +item.moneyA;
        } else if (type === "B") {
          sum += +item.moneyB;
        }
      }
      return sum;
    },
    // formedDateOfThisWeek(){
    //     let today = new Date();
    //     let this_year = today.getFullYear();
    //     let this_month = today.getMonth();
    //     let date = today.getDate();
    //     let day_num = today.getDay();
    //     let this_monday = date - day_num + 1;
    //     let this_sunday = this_monday + 6;
    //     let day = new String('日月火水木金土');

    //     //月曜日の年月日
    //     let start_date = new Date(this_year, this_month, this_monday);
    //         start_date = start_date.getFullYear() + "年" + (start_date.getMonth() + 1) + "月" + start_date.getDate() + "日" + " (" + day.charAt( start_date.getDay() ) + ")"
    //     //日曜日の年月日
    //     let end_date = new Date(this_year, this_month, this_sunday);
    //         end_date =  end_date.getFullYear() + "年" + (end_date.getMonth() + 1) + "月" + end_date.getDate() + "日" + " (" + day.charAt( end_date.getDay() ) +")"
    //     //文字列を作成
    //     let target_week = start_date + " ～ " + end_date;
    //     console.log(target_week)
    //     return target_week
    //   }
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Sample.vue